'use client';

import React, { FC, useEffect, useState } from 'react';

import {
  NotificationEnum,
  NotificationResponseType,
  NotificationType,
} from '@/api/services/GlobalService/types';
import Portal from '@/components/core/Portal';

import { getNotifications as requestNotifications } from '../notificationsRequest';

const Promo: FC = () => {
  const [promo, setPromo] = useState<NotificationType | null>();
  const [mounted, setMounted] = useState(false);

  const getNotifications = async () => {
    try {
      const data: NotificationResponseType = await requestNotifications();

      if (data?.query?.length) {
        // @ts-ignore
        const notification: NotificationType | undefined = data.query.find(
          // @ts-ignore
          ({ type }) => type === NotificationEnum.PromoPopup
        );
        setPromo(notification);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  };

  const handleCloseNotificationPanel = () => {
    setPromo(null);
    if (typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.setItem('hidePromoPopup', JSON.stringify(true));
    }
  };

  useEffect(() => {
    setMounted(true);
    if (typeof window !== 'undefined' && window.sessionStorage) {
      const hidePromoPopup = window.sessionStorage.getItem('hidePromoPopup');
      if (!hidePromoPopup) {
        getNotifications();
      }
    }
  }, []);

  const { title, description, imageUrl, submitUrl } = promo || {};

  if (!mounted) {
    return null;
  }

  if (promo) {
    return (
      <Portal id="modal-container">
        <div className="popupPromoWrp">
          <div className="popupPromoHolder" style={{ backgroundImage: `url(${imageUrl})` }}>
            <div className="popupPromoInner">
              <div className="popupPromoCloseWrp">
                <i className="bc-i-close popupPromoClose" onClick={handleCloseNotificationPanel} />
              </div>
              <div className="popupPromoContentWrp">
                <p className="popupPromoTitle">{title}</p>
                <p className="popupPromoTxt">{description}</p>
                <div className="popupPromoBtnWrp">
                  <div className="popupPromoBtnItem">
                    <button
                      className="button btnTypeBig btnTypeCopy fullWidth"
                      onClick={handleCloseNotificationPanel}
                    >
                      <p>Cancel</p>
                    </button>
                  </div>
                  <div className="popupPromoBtnItem">
                    <a href={submitUrl} className="button btnTypeBig btnTypeOrange fullWidth">
                      <p>Submit</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Portal>
    );
  }

  return null;
};

export default Promo;
